import { ActionIcon, Group, Image, Modal, Paper } from '@mantine/core';
import { IconDownload, IconX } from '@tabler/icons';

interface ImagePreviewModalProps {
  url: string | null;
  onClose: () => void;
}

function downloadImage(url: string) {
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = url.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((err) => {
      console.error('Error downloading:', err);
      window.open(url, '_blank');
    });
}

const overlayButtonSx = {
  color: '#fff',
  backgroundColor: 'rgba(0,0,0,0.5)',
  '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
};

export function ImagePreviewModal({ url, onClose }: ImagePreviewModalProps) {
  return (
    <Modal
      opened={!!url}
      onClose={onClose}
      centered
      padding={0}
      withCloseButton={false}
      size="auto"
      zIndex={2000}
      styles={{ modal: { backgroundColor: 'transparent', boxShadow: 'none' } }}
    >
      <Paper
        sx={{
          position: 'relative',
          backgroundColor: 'transparent',
          overflow: 'hidden',
        }}
      >
        <Group
          spacing="xs"
          sx={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}
        >
          <ActionIcon
            onClick={() => url && downloadImage(url)}
            variant="filled"
            color="dark"
            sx={overlayButtonSx}
            radius="xl"
            size="lg"
            title="Baixar imagem"
          >
            <IconDownload size={20} />
          </ActionIcon>
          <ActionIcon
            onClick={onClose}
            variant="filled"
            color="dark"
            sx={overlayButtonSx}
            radius="xl"
            size="lg"
            title="Fechar"
          >
            <IconX size={20} />
          </ActionIcon>
        </Group>
        <Image
          src={url || ''}
          alt="Preview"
          fit="contain"
          sx={{ maxWidth: '90vw', maxHeight: '90vh' }}
        />
      </Paper>
    </Modal>
  );
}
